import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D385 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D385 - Software Security and Testing</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 8.37 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            Read this guide first:{" "}
            <a href="https://www.reddit.com/r/wgu_devs/comments/17quy61/updated_112023_software_security_and_testing_d385/" target="_blank" rel="noreferrer">
              Software Security and Testing D385
            </a>
          </p>
          <p>Now my opinions:</p>
          <p>
            This test is actually not hard at all. In fact, it's not even a real
            test because the coding questions are literally the exact same in
            the OA as the PA—just with different variables. But the instructor
            doesn’t even have the answers to the PA, which is very stupid in my
            opinion.
          </p>
          <p>
            Here’s the answer sheet to the PA coding:
            <br />
            🔗{" "}
            <a href="https://glass-diadem-acc.notion.site/D385-Assessments-3261412dc25f4bce829d34341f33e8b3"  target="_blank" rel="noreferrer">
              D385 Assessments Answer Sheet
            </a>
          </p>
          <p>Make sure you do the PA coding like a million times and memorize it (well, understand it).</p>
          <p>Now, the funny part about this exam:
            <ul>
                <li>•	First try: I failed horribly. Which was so hard to believe because all my code worked! It was impossible for me to fail. When I texted the instructor, he said no one passes it the first time. WTF?</li>
                <li>•	Second try: Passed.</li>
                <li>•	Funniest part? Exact. Same. Questions. As the first OA.</li>
            </ul>
          </p>
          <p>
          So basically, this is a course where they give you the OA as the PA, you "fail" the first time, wonder what went wrong, and then pass the second time. 🤷‍♂️
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D385;
